import { useEffect } from 'react';
import Modal from '~/modules/Elements/Modal';
import SelectInputView from '~/routes/SelectInput/SelectInputView';

interface Props {
  onClose: () => void;
  closeButtonText: string;
  open: boolean;
}

export default function SelectInputModal({ onClose, closeButtonText, open }: Props) {
  useEffect(() => {
    if (!open) return;

    const html = document.documentElement;
    const previousUiMode = html.dataset.uiMode;
    html.dataset.uiMode = 'web';

    return () => {
      if (previousUiMode) html.dataset.uiMode = previousUiMode;
      else delete html.dataset.uiMode;
    };
  }, [open]);

  return (
    <Modal onClose={onClose} open={open} variant="preview">
      <div
        className={['preview-modal', 'h-[100dvh] w-screen', 'overflow-hidden', 'flex flex-col'].join(' ')}
        style={{ background: 'var(--walky-canvas)', color: 'var(--walky-ink)' }}
        data-modal-context="preview">
        <SelectInputView
          smooth={false}
          onBack={onClose}
          onFinish={onClose}
          closeButtonText={closeButtonText}
          skipText="Back"
          context="preview"
        />
      </div>
    </Modal>
  );
}
